function mbtiToResultArray(mbti) {
    if (typeof mbti !== 'string') {
        return null;
    }

    mbti = mbti.toUpperCase().trim();

    if (mbti.length !== 4 || !/^[I|E][S|N][T|F][J|P]$/.test(mbti)) {
        return null;
    }


    const result = [[0, 0], [0, 0], [0, 0], [0, 0]];
    for (let i = 0; i < mbti.length; i++) {
        const char = mbti[i];
        switch (char) {
            case 'E':
                result[0][1]++;
                break;
            case 'I':
                result[0][0]++;
                break;
            case 'S':
                result[1][0]++;
                break;
            case 'N':
                result[1][1]++;
                break;
            case 'T':
                result[2][1]++;
                break;
            case 'F':
                result[2][0]++;
                break;
            case 'J':
                result[3][0]++;
                break;
            case 'P':
                result[3][1]++;
                break;
            default:
                return null;
        }
    }
  
    return result;
}

export default mbtiToResultArray;